module.exports = __webpack_public_path__ + "img/ry2.c723d2ed.jpg";